const NotFoundPage = () => {
  return (
    <main className="main">
      <h2 className="error">ERROR 404</h2>
      <h2 className="error">The page you're looking for cannot be found</h2>
    </main>
  );
};

export default NotFoundPage;
